import {
  Award,
  BookOpen,
  Bug,
  Clock,
  Cloud,
  Database,
  GitBranch,
  Handshake,
  HeartPulse,
  Lock,
  type LucideIcon,
  Rocket,
  Ruler,
  Search,
  ShieldCheck,
  Sparkles,
  Target,
  TestTube,
  TrendingUp,
  Users,
  Wrench,
  Zap,
} from 'lucide-react'

/**
 * The icons a goal can be given, and their stored names.
 *
 * Curated rather than "any lucide icon": a picker of two thousand icons is a
 * search problem, and the point of the icon is that six cards in a grid are
 * told apart at a glance — which works better when the whole portal draws from
 * one small, recognizable set.
 *
 * `name` is what lands in team_goals.icon (0024). Add to this list freely; the
 * database doesn't know or care what's in it. Never RENAME an entry — the name
 * is the stored value, and renaming one silently resets every goal using it to
 * the fallback.
 */
export const GOAL_ICONS: Array<{ name: string; label: string; icon: LucideIcon }> = [
  { name: 'target', label: 'Target', icon: Target },
  { name: 'rocket', label: 'Rocket', icon: Rocket },
  { name: 'trending-up', label: 'Growth', icon: TrendingUp },
  { name: 'zap', label: 'Speed', icon: Zap },
  { name: 'clock', label: 'Time', icon: Clock },
  { name: 'shield-check', label: 'Quality', icon: ShieldCheck },
  { name: 'bug', label: 'Defects', icon: Bug },
  { name: 'test-tube', label: 'Testing', icon: TestTube },
  { name: 'git-branch', label: 'Delivery', icon: GitBranch },
  { name: 'cloud', label: 'Cloud', icon: Cloud },
  { name: 'database', label: 'Data', icon: Database },
  { name: 'lock', label: 'Security', icon: Lock },
  { name: 'users', label: 'Team', icon: Users },
  { name: 'handshake', label: 'Customers', icon: Handshake },
  { name: 'book-open', label: 'Learning', icon: BookOpen },
  { name: 'wrench', label: 'Tooling', icon: Wrench },
  { name: 'ruler', label: 'Estimation', icon: Ruler },
  { name: 'search', label: 'Discovery', icon: Search },
  { name: 'heart-pulse', label: 'Health', icon: HeartPulse },
  { name: 'award', label: 'Milestone', icon: Award },
  { name: 'sparkles', label: 'Innovation', icon: Sparkles },
]

/** What a goal with no icon — or one naming an icon since removed — gets. */
export const DEFAULT_GOAL_ICON = Target

/** The component for a stored name, falling back rather than rendering nothing. */
export function goalIcon(name: string | null | undefined): LucideIcon {
  if (!name) return DEFAULT_GOAL_ICON
  return GOAL_ICONS.find((i) => i.name === name)?.icon ?? DEFAULT_GOAL_ICON
}
